// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../projects/ProjectsPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BillsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BillFilter>;
  order?: Types.InputMaybe<Types.BillOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BillsQuery = { __typename?: 'Query', billsPage: { __typename?: 'BillsPage', entities: Array<{ __typename?: 'Bill', id: string, isTradePartnerCredit: boolean, tradePartnerNumber: string, billedInCents: number, paidInCents: number, balanceInCents: number, proposedAmountInCents: number, pendingReview: boolean, isProcessingReversal: boolean, dueDate?: Types.Scalars['Date']['input'] | null | undefined, billDate: Types.Scalars['Date']['input'], paidDate?: Types.Scalars['Date']['input'] | null | undefined, type: { __typename?: 'BillTypeDetail', code: Types.BillType, name: string }, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, approval?: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number }>, projectStage: { __typename?: 'ProjectStage', id: string, project: { __typename?: 'StandaloneProject', id: string, projectName: string } | { __typename?: 'Region', id: string, projectName: string } | { __typename?: 'Market', id: string, projectName: string } | { __typename?: 'Community', id: string, projectName: string } | { __typename?: 'Subdivision', id: string, projectName: string } | { __typename?: 'Lot', id: string, projectName: string } | { __typename?: 'Structure', id: string, projectName: string } | { __typename?: 'Unit', id: string, projectName: string } }, tradePartner: { __typename?: 'TradePartner', id: string, name: string, isLienWaiverReceiver: boolean }, lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, type: { __typename?: 'LienWaiverTypeDetail', code: Types.LienWaiverType, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: Types.LienWaiverCondition, name: string }, status: { __typename?: 'LienWaiverStatusDetail', code: Types.LienWaiverStatus, name: string } }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } }, projects: Array<{ __typename?: 'StandaloneProject', id: string, projectName: string } | { __typename?: 'Region', id: string, projectName: string } | { __typename?: 'Market', id: string, projectName: string } | { __typename?: 'Community', id: string, projectName: string } | { __typename?: 'Subdivision', id: string, projectName: string } | { __typename?: 'Lot', id: string, projectName: string } | { __typename?: 'Structure', id: string, projectName: string } | { __typename?: 'Unit', id: string, projectName: string }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }> };

export type BillsQueryBillFragment = { __typename?: 'Bill', id: string, isTradePartnerCredit: boolean, tradePartnerNumber: string, billedInCents: number, paidInCents: number, balanceInCents: number, proposedAmountInCents: number, pendingReview: boolean, isProcessingReversal: boolean, dueDate?: Types.Scalars['Date']['input'] | null | undefined, billDate: Types.Scalars['Date']['input'], paidDate?: Types.Scalars['Date']['input'] | null | undefined, type: { __typename?: 'BillTypeDetail', code: Types.BillType, name: string }, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, approval?: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number } | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number }>, projectStage: { __typename?: 'ProjectStage', id: string, project: { __typename?: 'StandaloneProject', id: string, projectName: string } | { __typename?: 'Region', id: string, projectName: string } | { __typename?: 'Market', id: string, projectName: string } | { __typename?: 'Community', id: string, projectName: string } | { __typename?: 'Subdivision', id: string, projectName: string } | { __typename?: 'Lot', id: string, projectName: string } | { __typename?: 'Structure', id: string, projectName: string } | { __typename?: 'Unit', id: string, projectName: string } }, tradePartner: { __typename?: 'TradePartner', id: string, name: string, isLienWaiverReceiver: boolean }, lienWaivers: Array<{ __typename?: 'LienWaiver', id: string, type: { __typename?: 'LienWaiverTypeDetail', code: Types.LienWaiverType, name: string }, condition: { __typename?: 'LienWaiverConditionDetail', code: Types.LienWaiverCondition, name: string }, status: { __typename?: 'LienWaiverStatusDetail', code: Types.LienWaiverStatus, name: string } }> };

export type BillsMarketInfoFragment = { __typename?: 'Market', id: string, name: string };

export type BillsInternalUserInfoFragment = { __typename?: 'InternalUser', id: string, name: string };

export type BillsProjectInfo_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, projectName: string };

export type BillsProjectInfo_Region_Fragment = { __typename?: 'Region', id: string, projectName: string };

export type BillsProjectInfo_Market_Fragment = { __typename?: 'Market', id: string, projectName: string };

export type BillsProjectInfo_Community_Fragment = { __typename?: 'Community', id: string, projectName: string };

export type BillsProjectInfo_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, projectName: string };

export type BillsProjectInfo_Lot_Fragment = { __typename?: 'Lot', id: string, projectName: string };

export type BillsProjectInfo_Structure_Fragment = { __typename?: 'Structure', id: string, projectName: string };

export type BillsProjectInfo_Unit_Fragment = { __typename?: 'Unit', id: string, projectName: string };

export type BillsProjectInfoFragment = BillsProjectInfo_StandaloneProject_Fragment | BillsProjectInfo_Region_Fragment | BillsProjectInfo_Market_Fragment | BillsProjectInfo_Community_Fragment | BillsProjectInfo_Subdivision_Fragment | BillsProjectInfo_Lot_Fragment | BillsProjectInfo_Structure_Fragment | BillsProjectInfo_Unit_Fragment;

export type TradePartnerInfoFragment = { __typename?: 'TradePartner', id: string, name: string };

export const BillsQueryBillFragmentDoc = gql`
    fragment BillsQueryBill on Bill {
  id
  isTradePartnerCredit
  tradePartnerNumber
  billedInCents
  paidInCents
  balanceInCents
  proposedAmountInCents
  pendingReview
  isProcessingReversal
  type {
    code
    name
  }
  source {
    code
    name
  }
  approval {
    id
    status {
      code
      name
    }
  }
  status {
    code
    name
  }
  dueDate
  billDate
  paidDate
  parents {
    id
    displayName
    accountingNumber
  }
  projectStage {
    id
    project {
      id
      projectName
    }
  }
  tradePartner {
    id
    name
    isLienWaiverReceiver
  }
  lienWaivers {
    id
    type {
      code
      name
    }
    condition {
      code
      name
    }
    status {
      code
      name
    }
  }
}
    `;
export const BillsMarketInfoFragmentDoc = gql`
    fragment BillsMarketInfo on Market {
  id
  name
}
    `;
export const BillsInternalUserInfoFragmentDoc = gql`
    fragment BillsInternalUserInfo on InternalUser {
  id
  name
}
    `;
export const BillsProjectInfoFragmentDoc = gql`
    fragment BillsProjectInfo on Project {
  id
  projectName
}
    `;
export const TradePartnerInfoFragmentDoc = gql`
    fragment TradePartnerInfo on TradePartner {
  id
  name
}
    `;
export const BillsDocument = gql`
    query Bills($filter: BillFilter, $order: BillOrder, $page: PageFilter) {
  billsPage(filter: $filter, order: $order, page: $page) {
    entities {
      ...BillsQueryBill
    }
    pageInfo {
      ...PageInfo
    }
  }
  projects {
    ...BillsProjectInfo
  }
  internalUsers {
    ...BillsInternalUserInfo
  }
  markets {
    ...BillsMarketInfo
  }
  tradePartners {
    ...TradePartnerInfo
  }
}
    ${BillsQueryBillFragmentDoc}
${PageInfoFragmentDoc}
${BillsProjectInfoFragmentDoc}
${BillsInternalUserInfoFragmentDoc}
${BillsMarketInfoFragmentDoc}
${TradePartnerInfoFragmentDoc}`;

/**
 * __useBillsQuery__
 *
 * To run a query within a React component, call `useBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBillsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillsQuery, BillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
      }
export function useBillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillsQuery, BillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
        }
export function useBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillsQuery, BillsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
        }
export type BillsQueryHookResult = ReturnType<typeof useBillsQuery>;
export type BillsLazyQueryHookResult = ReturnType<typeof useBillsLazyQuery>;
export type BillsSuspenseQueryHookResult = ReturnType<typeof useBillsSuspenseQuery>;
export type BillsQueryResult = Apollo.QueryResult<BillsQuery, BillsQueryVariables>;